import styled from 'styled-components';

// Styled Components
import {
  Tr,
  TextCell,
  TableContainer,
  FiltersContainer,
  SubContainerFilters,
  ContainerButtons,
  Container,
} from '../components/MainStyledComponents';

// Types
import {
  ArrowBottomStyledProps,
  ContainersLoadingProps,
  ShowFiltersButtonProps,
} from '../CheckBoxTagTable/types';

// Icons
import { ArrowBottom } from '../../../../assets/icons/ArrowBottom';

export const ContainerStyled = styled(Container)`
  position: relative;
`;

export const TableContainerStyled = styled(
  TableContainer
)<ContainersLoadingProps>`
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
`;

export const FiltersWithLoadingStyled = styled(
  FiltersContainer
)<ContainersLoadingProps>`
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
`;

export const ContainerLoader = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  z-index: 1;
`;

export const SubContainerFiltersStyled = styled(SubContainerFilters)``;

export const SubContainerHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ShowFiltersButton = styled.button<ShowFiltersButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  height: 2.3rem;
  border-radius: 0.3rem;
  transition: background 300ms;
  background: ${(props) => (props.isBlack ? props.theme.colors.black : props.theme.colors.garnet)};
`;

export const ArrowBottomStyled = styled(ArrowBottom)<ArrowBottomStyledProps>`
  transition: transform 300ms;
  transform: ${({isRotate}) => (isRotate ? null : 'rotate(-90deg)')};
  width: 1rem;
  height: 1rem;
  path {
    fill: white;
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.lightRed};
`;

export const TextCellStyled = styled(TextCell)`
  color: ${({ theme }) => theme.colors.black};
`;

export const ContainerButtonStyled = styled(ContainerButtons)`
  margin-left: -0.6rem;
`;
